import { req, post, get } from '@/plugins/axios'
import type { res } from './login'

// 授权操作

/**
 * 用户发起品牌授权申请
 * @param data
 * @returns
 */
export function brandAuthApply (data: any) {
  return post('/goods/brand/auth/apply', data)
}

/**
 * 用户品牌授权申请取消
 * @param data
 * @returns
 */
export function brandAuthCancel (data: any) {
  return req('/goods/brand/auth/cancel', data)
}

/**
 * 用户品牌授权申请修改
 * @param data
 * @returns
 */
export function brandAuthEdit (data: any) {
  return post('/goods/brand/auth/edit', data)
}

/**
 * 用户品牌授权申请提交
 * @param data
 * @returns
 */
export function brandAuthSubmit (data: any) {
  return req('/goods/brand/auth/submit', data)
}

// 授权查询

/**
 * 用户品牌授权申请分页查询(前台)
 * @param data
 * @returns
 */
export function brandAuthListPage (data: any) {
  return post('/goods/brand/auth/query/front/list/page', data)
}

/**
 * 客户品牌授权申请详情
 * @param data
 * @returns
 */
export function brandAuthDetail (data: any) {
  return req('/goods/brand/auth/query/detail', data)
}

/**
 * 客户品牌授权申请 审核记录查询
 * @param data
 * @returns
 */
export function brandAuthAuditList (data: any) {
  return req('/goods/brand/auth/query/audit/list/front', data)
}

/**
 * 客户品牌授权申请 审核记录查询
 * @param data
 * @returns
 */
export function brandAuthStatistic (data?: any) {
  return req('/goods/brand/auth/query/front/statistic', data)
}

/**
 * 客户品牌授权最近一次
 * @param data
 * @returns
 */
export function brandAuthLastWait (data?: any) {
  return req('/goods/brand/auth/query/front/last/wait', data)
}

// 品牌查询

/**
 * 品牌集查询列表
 * @param data
 * @returns
 */
export function brandSearchList (data: any) {
  return post('/goods/brand/search/queryBrandSet', data)
}

/**
 * 品牌集查询明细
 * @param data
 * @returns
 */
export function brandQuery (data: any) {
  return req('/goods/brand/search/detail', data)
}

/**
 * 品牌风格查询
 * @param data
 * @returns
 */
export function brandQueryStyles (data?: any) {
  return req('/goods/brand/style/query/all', data)
}

/**
 * 品牌名称查询
 * @param data
 * @returns
 */
export function brandQueryItems (data?: any) {
  return req('/goods/brand/queryBrandItem', data)
}

/**
 * 品牌名称查询
 * @param data
 * @returns
 */
export function brandQueryPage (data: any) {
  return req('/goods/brand/queryBrandItem/page', data)
}

/**
 * 品牌集
 * @param data
 * @returns
 */
export function brandQueryList (data: any) {
  return post('/goods/brand/search/queryBrandSet', data)
}

/**
 * 品牌集 带字搜索
 * @param data
 * @returns
 */
export function brandSearch (data: any) {
  return post('/goods/brand/search/searchBrandSet', data)
}

/**
 * 品牌集详情
 * @param data
 * @returns
 */

export function brandDetail (params: any) {
  return get('/goods/brand/search/detail', { params })
}

/**
 * 品牌集添加收藏
 * @param data
 * @returns
 */
export function brandAddFavorite (data: any) {
  return post(`/goods/favorite/brand/add?brandId=${data.brandId}`)
}

/**
 * 品牌集取消收藏
 * @param data
 * @returns
 */
export function brandRemoveFavorite (data: any) {
  return post(`/goods/favorite/brand/cancel?brandId=${data.brandId}`)
}

/**
 * 品牌集 搜索历史
 * @param data
 * @returns
 */
export function brandSearchHistory (): Promise<res> {
  return get('/goods/brand/search/history')
}

/**
 * 品牌收藏列表
 * @param data
 * @returns
 */
export function brandFavoriteList (data: any) {
  return post('/goods/favorite/brand/list', data)
}

// 首页

/**
 * 品牌滚动轮播
 * @param data
 * @returns
 */
export function brandBanner () {
  return get('/goods/brand/search/banner')
}

// 商品查询

/**
 * 商品是否授权
 * @param data
 * @returns
 */
export function listByProducts (data:any) {
  return post('/goods/brand/listByProducts', data)
}
